export default __webpack_public_path__ + "static/media/crystal_card_background_mobile.722cb105.png";